import { render, staticRenderFns } from "./DosesTab.vue?vue&type=template&id=1b5b5aba&"
import script from "./DosesTab.vue?vue&type=script&lang=js&"
export * from "./DosesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports